<!-- Translated: skip -->
<template>
  <Modal @close="closeModal" :wide="false" width="50vw" min-width="50vw">
    <h2 class="uppercase center" slot="header">Vanliga frågor</h2>
    <div v-for="({question, answer}, index) in faqs" :key="question" class="items-list">
      <Collapsable :title="question" :content="answer" />
    </div>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Collapsable from '@/components/components/Collapsable';

export default {
  components: {
    Modal,
    Collapsable,
  },
  data() {
    return {
      expanded: [],
      faqs: [
        {
          question: 'Vilka tider har backarna öppet?',
          answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        },
        {
          question: 'Vilka backar är det som har kvällsåkning',
          answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        },
      ],
    };
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    toggle(index) {
      if (this.expanded.includes(index)) {
        return this.expanded.pop(index);
      }
      return this.expanded.push(index);
    },
    isActive(index) {
      return this.expanded.includes(index);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
h2
  united-heavy()
.item
  border: 2px solid pink
  border-radius: 4px
  padding: .5em 1em;
  margin-bottom: 1em;
  width: 580px

  .item-header
    @extend .uppercase, .bold
    display: flex
    justify-content: space-between

    .icon
      color: red
      flex-grow: 0
      cursor: pointer
      margin-left: 1em
      font-size: 2em
</style>



// WEBPACK FOOTER //
// SkiSchoolFaq.vue?0fbc2267